import './Navigation.css';
import {
  Link
} from 'react-router-dom';
import Bottomnaventry from './Bottomnaventry';
import EntryConfig from './entryconfigType';


const navitems = [
  {
    img: "/icons/circle-info-solid.svg",
    img_alt: "info",
    link: "/info",
    text: "info"
  },
  {
    img: "/icons/user-solid.svg",
    img_alt: "user",
    link: "/user",
    text: "user"
  },
  {
    img: "/icons/hands-praying-solid.svg",
    img_alt: "sdm",
    link: "/sdm",
    text: "ŚDM"
  },
  {
    img: "/icons/poland.svg",
    img_alt: "poland",
    link: "/poland",
    text: "Poland"
  },
  {
    img:"/icons/campground-solid.svg",
    img_alt: "zhr",
    link: "/zhr",
    text: "ZHR"
  },
  {
    img: "/icons/location-dot-solid.svg",
    img_alt: "places",
    link: "/places",
    text: "miejsca"
  },
  {
    img: "/icons/house-solid.svg",
    img_alt: "home",
    link: "/",
    text: "home"
  }
]

const bottomnavitems = [
  {
    img: "/icons/map-location-dot-solid.svg",
    img_alt: "map",
    link: "/map",
    text: "mapa"
  },
  {
    img: "/icons/briefcase-solid.svg",
    img_alt: "useful",
    link: "/przydasie",
    text: "przydasie"
  },
  {
    img: "/icons/people-group-solid.svg",
    img_alt: "poland",
    link: "/poland",
    text: "Poland"
  }
]

function undo() {
  // eslint-disable-next-line no-restricted-globals
  history.back()
}

function NavEntry({conf}:{conf: EntryConfig}) {
  return (
    <div className='burger-item' key={conf.link}>
      <Link to={conf.link}>
        <img src={conf.img} alt={conf.img_alt} className='burg-img' />
      </Link>
    </div>
  );
}


function Navigation() {
  function changeVisibilityBurger() {
    document.getElementById('burgerMenu')?.click();
  }

  function Burger() {
    return <>
      <div id="burgerNav">
        {navitems.map((v,i) => <NavEntry conf={v} key={i}/>)}
      </div>
      <div onClick={changeVisibilityBurger} id='burgerOverlay' />
    </>
  }

  return (
    <>
      <div id="navigation">
        <img src="/icons/angle-left-solid.svg" alt="undo" id='undo' onClick={undo} />
        {bottomnavitems.map((v,i) => <Bottomnaventry conf={v} key={`bnav-${i}`}/>)}
        <label htmlFor="burgerMenu" >
          <img src="/icons/ellipsis-vertical-solid.svg" alt="menu" id='burger' />
        </label>
      </div>
      <>
        <input id="burgerMenu" type='checkbox' />
        <Burger />
      </>
    </>
  );
}

export default Navigation;